export type ScaleDetails = {
  Visible: boolean;
  Text: string;
  Width: number;
  Height: number;
};
// Microns per displayed (unzoomed canvas) pixel, derived from the image's physical width.
// Image.PixelSize is stored per image type (ef/fl/th) and the server always returns the
// ef one, so it can't be trusted for the image that is actually on screen.
export const getMicronsPerCanvasPixel = (
  tpObject: { crWidth: number; scalingWidth: number } | undefined,
  fallbackPixelSize: number,
) => {
  if (tpObject?.crWidth > 0 && tpObject?.scalingWidth > 0) {
    return tpObject.crWidth / tpObject.scalingWidth;
  }
  return fallbackPixelSize;
};

export default function RefreshScale(
  micronsPerPixel: number,
  zoomLevel: number,
  scaleBarWidth: number,
) {
  const scaleBarPanel: ScaleDetails = { Visible: false, Width: 0, Height: 0, Text: '' };
  scaleBarPanel.Visible = true;

  const scaleSize = (micronsPerPixel * scaleBarWidth) / zoomLevel;

  // Only display scale size if it represents at least 1 nanometer in length.
  if (scaleSize >= 0.001) {
    const { preRoundValue, postRoundValue, units } = RoundMicros(scaleSize);
    scaleBarPanel.Text = postRoundValue.toString() + ' ' + units;

    // Adjust the size of the scale bar based on the percentage the scale value changed.
    // Kept fractional (v3 truncated to whole pixels) so the bar length matches the label.
    scaleBarPanel.Width = scaleBarWidth * (postRoundValue / preRoundValue);

    // Looks like when the width is changed to 0 and the control is visible, Windows Forms
    // *seems* to set the height to 0.  Investigate if this becomes a priority for any reason.
    scaleBarPanel.Height = 6;
  } else {
    scaleBarPanel.Text = '< nm';
  }

  // Move units label to the right of the scale bar.
  return scaleBarPanel;
}
function RoundMicros(scale: number) {
  let preRoundValue = scale,
    units = '',
    postRoundValue;

  // If greater than 1000, convert to millis.
  if (preRoundValue > 1000) {
    units = 'mm';
    postRoundValue = RoundMicrosVal((preRoundValue = preRoundValue / 1000));
  } else if (preRoundValue < 1) {
    // If less than 1, convert to nanos.
    units = 'nm';
    postRoundValue = RoundMicrosVal((preRoundValue = preRoundValue * 1000));
  } else {
    units = 'µm';
    postRoundValue = RoundMicrosVal(preRoundValue);
  }
  return { preRoundValue, postRoundValue, units };
}

function RoundMicrosVal(val: number) {
  if (val >= 1000) {
    return Round(val, 3);
  } else if (val >= 100) {
    return Round(val, 2);
  } else if (val >= 10) {
    return Round(val, 1);
  } else if (val >= 1) {
    return Round(val, 0);
  }

  return val;
}

function Round(val: number, digit: number) {
  if (digit < 0) {
    return val.toFixed(digit);
  }
  // return Math.Round(val, -digit);

  return parseInt((val / Math.pow(10, digit) + 0.5).toString()) * Math.pow(10, digit);
}
